import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useCanSavePaymentMethod } from '#src/app/shared/hooks/payments';
import { useLoginState } from '#src/app/shared/hooks/session';

import type { PromoteFormData } from '../../formData';

type Result = {
	amount: number;
	email: string;
	name: string;
	firstName: string;
	lastName: string;
	isPublic: boolean;
	shouldSavePaymentMethod: boolean;
};

function getInitialAmount(
	params: PromoteFormData,
	variation: ReturnType<typeof usePsfPromoteOrSharePageData>['data']['promoteShareOnComboExperiment']['variation'],
): number {
	if (variation !== 'variant_1') return 0;
	return params.amountChoices[0]?.amount ?? 0;
}

export function useStateInitData(params: PromoteFormData): Result {
	const { cookies } = useUtilityContext();
	const loginState = useLoginState();
	const canSavePaymentMethod = useCanSavePaymentMethod(params.featureConfigs.doubleOptinEnabledNewUser);
	const {
		data: { promoteShareOnComboExperiment },
	} = usePsfPromoteOrSharePageData();

	const isSecureGuest = loginState === 'GUEST' && params.featureConfigs.doubleOptinEnabledNewUser;
	const petitionPublicSignatureCookie = cookies.get(`app_meta_public_signature_${params.petition.id}`);

	const isPublic = isSecureGuest ? false : !!petitionPublicSignatureCookie;

	return {
		amount: getInitialAmount(params, promoteShareOnComboExperiment.variation),
		email: params.user.email,
		name: params.user.name,
		firstName: params.user.firstName,
		lastName: params.user.lastName,
		isPublic,
		shouldSavePaymentMethod: canSavePaymentMethod,
	};
}
